// module imports
import { useDispatch } from 'react-redux';
// module imports(lib)
import { hideProcessing, showProcessing } from '@/shared/lib/store/processing';

/**
 * useProcessing Custom Hook
 *
 * ローディング表示機能を使用するためのカスタムフック。
 * コンポーネントから成功、エラー、警告、情報メッセージを表示可能。
 *
 * @description
 * - Redux の dispatch を内部で使用
 *
 * @shared/hooks
 * FSD アーキテクチャの shared/hooks レイヤー。
 * アプリケーション全体で共有するユーティリティ。
 */

/** useProcessing フックの戻り値の型 */
interface UseProcessingReturn {
  /** ローディングの表示 */
  show: () => void;
  /** ローディングの非表示 */
  hide: () => void;
}

/**
 * ローディング表示操作用のカスタムフック
 *
 * @returns ローディング表示操作関数群
 */
export const useProcessing = (): UseProcessingReturn => {
  const dispatch = useDispatch();

  /** ローディング表示関数 */
  const show = () => {
    dispatch(showProcessing());
  };

  /** ローディング非表示関数 */
  const hide = () => {
    dispatch(hideProcessing());
  };

  return {
    show,
    hide,
  };
};
